var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-modal-header.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "loyalty/templates/loyalty-modal-header.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("staticUrl")) {
var t_4 = t_1.staticUrl;
} else {
cb(new Error("cannot import 'staticUrl'")); return;
}
context.setVariable("staticUrl", t_4);
output += "<div class=\"o-row\">\n    <div class=\"o-column o-extra-small--12 o-small--10 o-large--8 o-small--centered u-centered-content c-modal-loyalty__sign-up-container\">\n\n        <h1 class=\"c-modal-loyalty__h1\">\n            <img class=\"c-modal-loyalty__logo\" src=\"";
output += runtime.suppressValue((lineno = 6, colno = 62, runtime.callWrap(t_4, "staticUrl", context, ["/images/modal/anthro-perks-logo.svg"])), env.opts.autoescape);
output += "\" />\n        </h1>\n\n        <h5 class=\"c-modal-loyalty__h5\">\n            ";
output += runtime.suppressValue((lineno = 10, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_sign-up-modal-message"])), env.opts.autoescape);
output += "\n        </h5>\n\n        <p class=\"c-modal-loyalty__p\">\n            ";
output += runtime.suppressValue(env.getFilter("markdown_nowrap").call(context, (lineno = 14, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_sign-up-modal-learn-more-link"]))), env.opts.autoescape);
output += "\n        </p>\n\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-modal-header.j2"] , dependencies)